import { makeAutoObservable, runInAction } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export default class OrdersStore {
	constructor() {
		makeAutoObservable(this);
		makePersistable(this, {
			name: 'OrdersStore',
			properties: ['orders', 'ordersAnalysis', 'design', 'designList'],
		});
	}

	orders = [];
	ordersAnalysis = [];
	design = {};
	designList = [];

	reset = () => {
		this.orders = [];
		this.ordersAnalysis = [];
		this.designList = [];
	};

	setOrders = async state => {
		runInAction(async () => {
			this.orders = state;
		});
	};

	setOrdersAnalysis = async state => {
		runInAction(async () => {
			this.ordersAnalysis = state;
		});
	};

	setDesign = async state => {
		runInAction(async () => {
			this.design = state;
		});
	};
	setDesignList = async state => {
		runInAction(async () => {
			this.designList = state;
		});
	};
}
